<template>
  <v-dialog
    v-if="deviceWidth <= 480"
    v-model="dateRangeModel"
    :close-on-content-click="false"
    transition="scale-transition"
    :offset-y="true"
    min-width="auto"
    max-width="550px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        dense
        hide-details
        v-model="datesModel"
        :label="label ? label : 'Choose dates'"
        prepend-icon="mdi-calendar"
        v-bind="attrs"
        v-on="on"
        clearable
        @click:clear="onClearDates"
      ></v-text-field>
    </template>
    <RangeDatePicker
      :menuModel="dateRangeModel"
      v-model="datesModel"
      :showButtons="showButtons"
      :type="type"
      @onOkClick="onOkClick"
      @onCancelClick="onCancelClick"
      @onDateMenuClose="onDateMenuClose"
    />
  </v-dialog>
  <v-menu
    v-else
    v-model="dateRangeModel"
    :close-on-content-click="false"
    transition="scale-transition"
    :offset-y="true"
    min-width="auto"
    max-width="550px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        dense
        hide-details
        v-model="datesModel"
        :label="label ? label : 'Choose dates'"
        prepend-icon="mdi-calendar"
        v-bind="attrs"
        v-on="on"
        clearable
      ></v-text-field>
    </template>
    <RangeDatePicker
      :menuModel="dateRangeModel"
      v-model="datesModel"
      :showButtons="showButtons"
      :type="type"
      @onOkClick="onOkClick"
      @onCancelClick="onCancelClick"
      @onDateMenuClose="onDateMenuClose"
    />
  </v-menu>
</template>
<script>
export default {
  name: 'RangeDatePickerMenu',
  components: {
    RangeDatePicker: () => import('@/components/global/RangeDatePicker.vue')
  },
  props: {
    value: {
      required: false
    },
    label: {
      required: false
    },
    showButtons: {
      required: false,
      type: Boolean,
      default: false
    },
    type: {
      required: false
    }
  },
  data () {
    return {
      dateRangeModel: false,
      deviceWidth: window.innerWidth
    }
  },
  computed: {
    datesModel: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val || [])
      }
    }
  },
  mounted () {
  },
  methods: {
    onOkClick (e) {
      this.dateRangeModel = false
      this.$emit('onOkClick', this.datesModel)
    },
    onCancelClick () {
      this.dateRangeModel = false
    },
    onDateMenuClose () {
      this.$emit('onDateMenuClose')
    },
    onClearDates () {
      this.datesModel = []
      this.$emit('onClearDates')
    }
  }
}
</script>
